import { RootState } from 'ReduxConfig/store';

export const selector = ({ quotations }: RootState) => ({
  pagination: quotations.pagination,
  list: quotations.list,
  pending: quotations.pending,
  resultsFound: quotations.list.length > 0
});
